import React, { useEffect, useRef } from 'react';
import Icon from '../../../components/AppIcon';

const LiveBidFeed = ({ bids = [], newBidFlash }) => {
  const feedRef = useRef(null);

  useEffect(() => {
    if (feedRef?.current) {
      feedRef.current.scrollTop = 0;
    }
  }, [bids]);

  const formatTime = (dateStr) => {
    const d = new Date(dateStr);
    return d?.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
  };

  return (
    <div className="bg-card border border-border rounded-xl overflow-hidden flex flex-col h-full">
      <div className="flex items-center justify-between px-4 py-3 border-b border-border bg-muted/20">
        <div className="flex items-center space-x-2">
          <span className="w-2 h-2 rounded-full bg-success animate-pulse" />
          <span className="text-sm font-semibold text-card-foreground">Live Bid Feed</span>
        </div>
        <span className="text-xs text-muted-foreground">{bids?.length} bids</span>
      </div>

      <div ref={feedRef} className="flex-1 overflow-y-auto divide-y divide-border/50 max-h-80">
        {bids?.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-10 text-center px-4">
            <Icon name="Activity" size={28} className="text-muted-foreground mb-2" />
            <p className="text-sm text-muted-foreground">No bids yet. Be the first!</p>
          </div>
        ) : (
          bids?.map((bid, idx) => (
            <div
              key={bid?.id || idx}
              className={`flex items-center justify-between px-4 py-2.5 transition-colors duration-300 ${
                idx === 0 && newBidFlash ? 'bg-primary/10' : 'hover:bg-muted/20'
              }`}
            >
              <div className="flex items-center space-x-3 min-w-0">
                <div className="w-7 h-7 rounded-full bg-muted flex items-center justify-center flex-shrink-0 overflow-hidden">
                  {bid?.bidder?.avatar_url ? (
                    <img src={bid?.bidder?.avatar_url} alt={bid?.bidder?.full_name || 'Bidder'} className="w-full h-full object-cover" />
                  ) : (
                    <Icon name="User" size={14} className="text-muted-foreground" />
                  )}
                </div>
                <div className="min-w-0">
                  <p className="text-xs font-medium text-card-foreground truncate">
                    {bid?.bidder?.full_name || 'Anonymous'}
                  </p>
                  <p className="text-xs text-muted-foreground">{formatTime(bid?.created_at)}</p>
                </div>
              </div>
              <div className="flex items-center space-x-1 flex-shrink-0 ml-2">
                {idx === 0 && (
                  <span className="text-xs bg-success/10 text-success px-1.5 py-0.5 rounded font-medium">Top</span>
                )}
                <span className="text-sm font-bold text-primary">
                  ${parseFloat(bid?.bid_amount || 0)?.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                </span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default LiveBidFeed;
